import React from 'react';
import PropTypes from 'prop-types';
import * as S from './Image.styles';
import { BrandAssets } from './Brand/BrandAssets.inner';
import { IllustrationAssets } from './Illustration/IllustrationAssets.inner';

const ImgSource = { ...BrandAssets, ...IllustrationAssets };

const Image = ({ alt, cursor, height, name, width, isExternalSrc }) => {
  const ImageToRender = isExternalSrc
    ? `${name}`
    : ImgSource[`${name}`] || false;

  return (
    ImageToRender && (
      <S.Image
        cursor={cursor}
        width={width}
        height={height}
        src={ImageToRender}
        alt={alt}
        data-imageName={alt}
      />
    )
  );
};

Image.defaultProps = {
  cursor: 'default',
  height: 24,
  width: 32,
  isExternalSrc: false,
};

Image.propTypes = {
  alt: PropTypes.string.isRequired,
  cursor: PropTypes.oneOf(['not-allowed', 'pointer', 'default', 'none']),
  name: PropTypes.string.isRequired,
  height: PropTypes.number,
  width: PropTypes.number,
  isExternalSrc: PropTypes.bool,
};

export default Image;
